import { useEffect } from 'react';
import '@/App.css';
import '@/index.css';
import Lenis from '@studio-freight/lenis';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Founder from './components/Founder';
import Team from './components/Team';
import Contact from './components/Contact';
import { Toaster } from 'sonner';

function App() {
  useEffect(() => {
    // Initialize smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <About />
          <Services />
          <Founder />
          <Team />
          <Contact />
        </main>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </LanguageProvider>
  );
}

export default App;
